'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["colorSet", "className", "isVisible"];
import React from 'react';
import cx from 'classnames';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { addColorSet, cssSpacing, defaultColorSet, overlay, rootStyle, textClass } from "../../styles/index.mjs";
import { StatefulTooltip } from "./StatefulTooltip.mjs";
import styled, { css } from "../../styled-components.mjs";
export var TooltipWrapper = styled.div.withConfig({
  displayName: "Tooltip__TooltipWrapper",
  componentId: "sc-muq3yw-0"
})(["", ""], function (_ref) {
  var $isVisible = _ref.$isVisible;
  return css(["", ";", ";padding-block:", ";padding-inline:", ";text-transform:initial;color:var(--text-base,", ");overflow-wrap:break-word;opacity:", ";"], rootStyle(), overlay({
    maxWidth: '240px'
  }), cssSpacing('tighter-2', '8px'), cssSpacing('tighter', '12px'), defaultColorSet.text.base, $isVisible ? 1 : 0);
});

/**
 * The Tooltip displays a text label when users hover over or focus on an element.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-tooltip--docs) |
 * [Encore site](https://encore.spotify.net/web/components/tooltip) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Tooltip) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=0-1543&t=A8elpsiQkQlIZCx3-1)
 */
export var Tooltip = /*#__PURE__*/React.forwardRef(function Tooltip(_ref2, ref) {
  var _ref2$colorSet = _ref2.colorSet,
    colorSet = _ref2$colorSet === void 0 ? 'base' : _ref2$colorSet,
    className = _ref2.className,
    _ref2$isVisible = _ref2.isVisible,
    isVisible = _ref2$isVisible === void 0 ? true : _ref2$isVisible,
    props = _objectWithoutProperties(_ref2, _excluded);
  return props.trigger ? /*#__PURE__*/React.createElement(StatefulTooltip, Object.assign({
    ref: ref,
    className: addColorSet(colorSet, className),
    role: "tooltip",
    "data-encore-id": ENCORE_DATA_IDS.Tooltip
  }, props)) : /*#__PURE__*/React.createElement(TooltipWrapper, Object.assign({
    $isVisible: isVisible,
    ref: ref,
    className: cx(textClass('bodySmall'), addColorSet(colorSet, className)),
    role: "tooltip",
    "data-encore-id": ENCORE_DATA_IDS.Tooltip
  }, props));
});